/**
 * Pre-property wizard answers (ICP + goal). Survives refresh until a site is
 * created and the same fields are copied onto site-context.
 */
import {
  isOnboardingGoalId,
  isOnboardingIcpId,
  type OnboardingGoalId,
  type OnboardingIcpId,
} from "@/lib/types/onboarding-goal"

const DRAFT_KEY = "humblytics:onboarding-draft:v1"

type OnboardingDraft = {
  icp?: OnboardingIcpId | null
  goal?: OnboardingGoalId | null
}

export function readOnboardingDraft(): OnboardingDraft {
  try {
    const raw = sessionStorage.getItem(DRAFT_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw) as OnboardingDraft
    return {
      icp: isOnboardingIcpId(parsed.icp) ? parsed.icp : null,
      goal: isOnboardingGoalId(parsed.goal) ? parsed.goal : null,
    }
  } catch {
    return {}
  }
}

export function writeOnboardingDraft(patch: OnboardingDraft): OnboardingDraft {
  const prev = readOnboardingDraft()
  const next: OnboardingDraft = {
    icp: patch.icp !== undefined ? patch.icp : prev.icp,
    goal: patch.goal !== undefined ? patch.goal : prev.goal,
  }
  try {
    sessionStorage.setItem(DRAFT_KEY, JSON.stringify(next))
  } catch {
    // Best-effort
  }
  return next
}
